/**
 * The fund id of the in-memory auth session, mirrored into a module-level
 * value so the API client can read it without importing the auth store
 * (which would close an import cycle through the auth API client).
 *
 * The store publishes on every transition. Until it does, no session is
 * known and callers fall back to the persisted session.
 */

export interface ActiveFundContext {
  /** True once an authenticated session exists in memory. */
  hasSession: boolean;
  fundId: string | null;
}

const NO_SESSION: ActiveFundContext = { hasSession: false, fundId: null };

let current: ActiveFundContext = NO_SESSION;

export function publishActiveFundContext(context: ActiveFundContext): void {
  current = context;
}

export function readActiveFundContext(): ActiveFundContext {
  return current;
}

export function resetActiveFundContext(): void {
  current = NO_SESSION;
}
